/** @format */

import React from 'react'
import { Divider } from '@king-design/react'
import styled from 'styled-components'
import { ClearIcon, ZoomInIcon, ZoomOutIcon, UndoIcon, RedoIcon, SaveIcon } from 'src/assets/icon'
import variable from 'src/static/styles/var'
import { GraphX6Ref } from 'src/components/GraphX6/types'
interface ToolBarProps {
  className?: string
  historyChange: { canRedo: boolean; canUndo: boolean }
  graphRef: React.RefObject<GraphX6Ref>
}
const ToolBar: React.FC<ToolBarProps> = ({ className, historyChange, graphRef }) => {
  const { canRedo, canUndo } = historyChange
  const handleUndo = () => {
    if (canUndo) {
      graphRef.current?.graph?.undo()
    }
  }
  const handleRedo = () => {
    if (canRedo) {
      graphRef.current?.graph?.redo()
    }
  }
  const handleZoomIn = () => {
    graphRef.current?.graph?.zoom(0.2)
  }
  const handleZoomOut = () => {
    graphRef.current?.graph?.zoom(-0.2)
  }
  const handleClear = () => {
    graphRef.current?.graph?.clearCells()
  }
  const handleSave = () => {
    graphRef.current?.graph?.exportPNG('flowchart.png')
  }
  return (
    <div className={className}>
      <a onClick={handleClear}>
        <ClearIcon />
      </a>
      <Divider type="vertical"></Divider>
      <a onClick={handleZoomIn}>
        <ZoomInIcon />
      </a>
      <a onClick={handleZoomOut}>
        <ZoomOutIcon />
      </a>
      <Divider type="vertical"></Divider>
      <a onClick={handleUndo}>
        <UndoIcon className={!canUndo ? 'disabled' : ''} />
      </a>
      <a onClick={handleRedo}>
        <RedoIcon className={!canRedo ? 'disabled' : ''} />
      </a>
      <Divider type="vertical"></Divider>
      <a onClick={handleSave}>
        <SaveIcon />
      </a>
    </div>
  )
}

export default styled(ToolBar)`
  display: flex;
  align-items: center;
  height: 14px;
  .icon {
    cursor: pointer;
    margin: 0 4px;
    &:hover {
      fill: ${variable.primaryColor};
    }
    &.disabled {
      fill: ${variable.disableColor};
      cursor: not-allowed;
      &:hover {
        fill: ${variable.disableColor};
      }
    }
  }
  .k-default.k-vertical {
    margin: 0 4px;
  }
`
